import React from "react";
import LegalLayout from "../components/LegalLayout";
import { termsAndConditionsContent } from "../data/termsAndConditionsContent";

const TermsAndConditionsPage = () => (
  <LegalLayout
    label="Legal"
    title={<>Terms &amp; Conditions</>}
    subtitle="Please read these terms carefully before using our website or services."
    intro="These Terms &amp; Conditions govern your use of O3S' services and website. By accessing or using our services, you agree to be bound by these terms and applicable laws."
    sections={termsAndConditionsContent}
    contactText="Questions regarding these terms?"
    variant="default"
  />
);

export default TermsAndConditionsPage;
